const state = {
  userId: null,
  amount: null,
  currency: null,
  paymentPeriod: null,
  monthlyPayment: null,
  isTermsAndConditionConfirmed: false,
  currentStep: 1,
  isRegistrationSuccessful: false
};

module.exports = {
  state
};